import clsx from 'clsx';
import React from 'react';

function Circle({ shadow, className, children }) {
    return <div className={clsx('p-[5px] rounded-full', shadow ? 'shadow-outer' : '', className)}>{children}</div>;
}

export default Circle;
